<template>
  <div class="container">
    <div class="row">
      <amf-input :readonly="readOnly" label="Number of insured participants in medical plans only " :columns="6" v-model="numberOfInsured" :validator="$v.numberOfInsured" />
      <amf-select :readonly="readOnly" label="Invoice Letter Type" caption="--Select Invoice Letter Type--" :columns="6"
                  v-model="invoiceLetterType"
                  :options="invoiceLetterTypes" mapId="id"
                  :validator="$v.invoiceLetterType"/>
      <amf-checkbox :readonly="readOnly" label="Employer wants Ameriflex to bill for Retiree and/or Leave of Absence premiums (not COBRA related)" :columns="3" v-model="isDB" /> 
      <amf-checkbox :readonly="readOnly" v-if="isCobraDirectBill" label="Auto-Elect Direct Bill members into plans" :columns="3" v-model="autoElectDB"/>
      <amf-checkbox :readonly="readOnly" label="State Continuation (MN, NY, or IL Only) *Refers to an extension of the Federal COBRA benefits after the initial period of 18 months of Federal COBRA would normally end. Additional fees may apply."
                  :columns="3"
                  v-model="stateContinuation" />
    </div>
    <div v-if="stateContinuation" class="row form-group row-mw">
      <amf-multiple-select :readonly="readOnly" label='State(s) to Administer' v-model="selectedCobraStates" :options="cobraStates" :columns="3" :validator="$v.selectedCobraStates"/>
    </div>
  </div>
</template>

<script>
import { cobraConstants } from "../cobra/cobra-constants";
import {amfx} from "../framework/utils/amfx";
import {toastService} from "../framework";

export default ({
  data() {
    return {
      employerId: null,
      defaultCoverageEndRule: null,
      invoiceLetterType: null,
      stateContinuation: false,
      cobraStates: ['IL', 'MN', 'NY', 'TX'],
      selectedCobraStates: [],
      statesToAdminister: null,
      autoElectDB: false,
      numberOfInsured: null,
      isDB: false,
    };
  },
  computed: {
    ...amfx.map('employer/cobra', 'xEmployerId,xDefaultCoverageEndRule,xInvoiceLetterType,xStateContinuation,xStatesToAdminister,xIsDB,xAutoElectDB,xNumberOfInsured'),
    title() {
      return "Cobra Setup";
    },
    buttons() {
      return 'Save/Cancel';
    },
    invoiceLetterTypes() {
      return cobraConstants.INVOICE_LETTER_TYPES;
    },
    isCobraDirectBill() {
      if (!this.isDB) {
        this.autoElectDB = false;
      }
      return this.isDB;
    },
    readOnly() {
      return !this.can.editCobra;
    }
  },
  async created() {
    this.employerId = this.xEmployerId;
    this.defaultCoverageEndRule = this.xDefaultCoverageEndRule;
    this.invoiceLetterType = this.xInvoiceLetterType;
    this.stateContinuation = this.xStateContinuation;
    this.selectedCobraStates = this.xStatesToAdminister? this.xStatesToAdminister.split(",") : [];
    this.isDB = this.xIsDB;
    this.autoElectDB = this.xAutoElectDB;
    this.numberOfInsured = this.xNumberOfInsured;
  },
  methods: {
    ...amfx.map('employer/cobra', 'update'),
    async save() {
      this.statesToAdminister = this.selectedCobraStates.join(",");
      await this.update(this.$data);
      toastService.success(`Employer COBRA Setup updated.`);
    }
  },
  validations() {
    return {
      invoiceLetterType: v.build(v.required()),
      selectedCobraStates: v.build(v.requiredIf(() => {
                return this.stateContinuation === true;
      })),
      numberOfInsured: v.build(v.required(), v.custom(x => x > 0, "Must be greater than zero")),
    }
  },
})
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/newCobra/NewCobraSetup.vue